import { instagram, instagramQueries } from '@round/api';
import { useQuery } from '@tanstack/react-query';
import { Meta } from './TopPosts';

const postsQuery = instagramQueries.post.options.list;

export function useTopPosts(params: instagram.GetInstagramPostsParams) {
    const { data, status, isFetching } = useQuery({
        ...postsQuery(params),
        // to preserve count on pagination
        placeholderData: (query) =>
            query
                ? {
                      ...query,
                      results: [],
                  }
                : undefined,
    });

    const meta: Meta = {
        isLoading: isFetching,
    };

    return {
        rows: data?.results ?? [],
        count: data?.count,
        status,
        meta,
    };
}
